export default [
  {
    path: '/profissional/atendimento',
    name: 'profissional-atendimento',
    component: () => import('@/views/modules/profissional/GridProfissional.vue'),
    meta: {
      action: 'ROLE_PROFISSIONAL',
      resource: 'ACL',
    },
  },
  {
    path: '/profissional/atendimentoLegado',
    name: 'profissional-atendimento-legacy',
    component: () => import('@/views/modules/profissional/GridProfissionalLegado.vue'),
    meta: {
      action: 'ROLE_PROFISSIONAL',
      resource: 'ACL',
    },
  },
]
